<template>
  <div class="page-title-box">
    <div class="row align-items-center">
      <div class="col-sm-6">
        <h4 class="page-title">Credenciais</h4>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-right">
          <li class="breadcrumb-item"><a href="#">Inicio</a></li>
          <li class="breadcrumb-item">Professor</li>
          <li class="breadcrumb-item active">Credenciais</li>
        </ol>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="col-xl-6 col-xxl-6 col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="settings-form">
                <h4 class="text-primary">Actualizar a Senha</h4>
                <form @submit.prevent="submitForm">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>Senha Actual</label>
                      <div class="input-group-append">
                        <input
                          v-model="formData.senha_actual"
                          :type="showPassword ? 'text' : 'password'"
                          placeholder="Senha Actual"
                          class="form-control"
                        />
                        <span class="p-viewer" @click="showPasswordClick">
                          <i
                            v-if="showPassword == true"
                            class="fa fa-eye"
                            aria-hidden="true"
                          >
                          </i>
                          <i v-else class="fa fa-eye-slash" aria-hidden="true">
                          </i>
                        </span>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label>Nova Senha</label>
                      <div class="input-group-append">
                        <input
                          v-model="formData.nova_senha"
                          :type="showPasswordNew ? 'text' : 'password'"
                          placeholder="Nova Senha"
                          class="form-control"
                          @input="validatePassword"
                        />
                        <span class="p-viewer" @click="showPasswordClickNew">
                          <i
                            v-if="showPasswordNew == true"
                            class="fa fa-eye"
                            aria-hidden="true"
                          >
                          </i>
                          <i v-else class="fa fa-eye-slash" aria-hidden="true">
                          </i>
                        </span>
                      </div>
                    </div>
                    <p v-if="passwordError" style="color: red; font-size: 11px">
                      {{ passwordError }}
                    </p>
                  </div>
                  <div class="form-group">
                    <label>Confirmar Senha</label>
                    <div class="input-group-append">
                      <input
                        v-model="formData.confirmar_senha"
                        :type="showPasswordConf ? 'text' : 'password'"
                        placeholder="Confirmar Senha"
                        class="form-control"
                      />
                      <span class="p-viewer" @click="showConfPasswordClick">
                        <i
                          v-if="showPasswordConf == true"
                          class="fa fa-eye"
                          aria-hidden="true"
                        >
                        </i>
                        <i v-else class="fa fa-eye-slash" aria-hidden="true">
                        </i>
                      </span>
                    </div>
                  </div>
                  <p v-if="passwordConfirm" style="color: red; font-size: 11px">
                    {{ passwordConfirm }}
                  </p>

                  <button
                    class="btn btn-primary float-right"
                    :disabled="loading"
                    type="submit"
                  >
                    Actualizar
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Loading :loadingData="loading"></Loading>
</template>

<script setup>
import toastr from "toastr";
import { ref } from "vue";
import passwordStoreModule from "../login/passwordStoreModule";
import Loading from "@/components/Loading.vue";
import { toast } from "vue3-toastify";

const formData = ref({
  senha_actual: "",
  nova_senha: "",
  confirmar_senha: "",
});
const passwordError = ref("");
const passwordConfirm = ref("");
const passwordValid = ref(false);
const showPassword = ref(false);
const showPasswordConf = ref(false);
const showPasswordNew = ref(false);
const loading = ref(false);

function showPasswordClick() {
  if (formData.value.senha_actual == "") {
    return toast.info("por favor informe senha", {
      autoClose: 1000,
    });
  }
  showPassword.value = !showPassword.value;
}

function showPasswordClickNew() {
  if (formData.value.nova_senha == "") {
    return toast.info("por favor informe nova senha", {
      autoClose: 1000,
    });
  }
  showPasswordNew.value = !showPasswordNew.value;
}

function showConfPasswordClick() {
  if (formData.value.confirmar_senha == "") {
    return toast.info("por favor informe senha", {
      autoClose: 1000,
    });
  }
  showPasswordConf.value = !showPasswordConf.value;
}

async function submitForm() {
  try {
    loading.value = true;
    if (formData.value.senha_actual == "") {
      loading.value = false;

      toast.info("Por favor preencha o campo senha actual", {
        autoClose: 1000,
      });
      return;
    }
    if (formData.value.nova_senha == "") {
      loading.value = false;

      toast.info("Por favor preencha o campo nova senha", {
        autoClose: 1000,
      });
      return;
    }
    if (formData.value.nova_senha == "") {
      loading.value = false;

      toast.info("Por favor preencha o campo confirmar senha", {
        autoClose: 1000,
      });
      return;
    }

    if (formData.value.confirmar_senha != formData.value.nova_senha) {
      formData.value = "Por favor confirme a senha";
    }
    const resp = await passwordStoreModule.actions.updatePassword({
      senha_actual: formData.value.senha_actual,
      nova_senha: formData.value.nova_senha,
      confirmar_senha: formData.value.confirmar_senha,
    });

    if (resp.data == 1) {
      toast.success("Senha actualizada com sucesso", {
        autoClose: 1000,
      });
      formData.value.senha_actual = "";
      formData.value.nova_senha = "";
      formData.value.confirmar_senha = "";
    } else {
      toast.info(resp.data.message, {
        autoClose: 1000,
      });
    }
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

function validatePassword() {
  // Requisitos mínimos de segurança
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(formData.value.nova_senha);
  const hasLowerCase = /[a-z]/.test(formData.value.nova_senha);
  const hasDigit = /\d/.test(formData.value.nova_senha);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(
    formData.value.nova_senha
  );

  // Verifica se a senha atende aos critérios
  if (
    formData.value.nova_senha.length < minLength ||
    !hasUpperCase ||
    !hasLowerCase ||
    !hasDigit ||
    !hasSpecialChar
  ) {
    if (formData.value.nova_senha !== "") {
      passwordError.value =
        "A senha deve ter pelo menos 8 caracteres, incluindo maiúsculas, minúsculas, números e caracteres especiais.";
    }
  } else {
    passwordValid.value = true;
    passwordError.value = null;
  }

  if (formData.value.nova_senha == "") {
    passwordError.value = null;
  }
}
</script>
